import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { SegmentSaveData } from 'slices/aiConversations/segmentVisualizationTypes'
import {
  createAnotherSegmentThunk,
  saveSegmentThunk,
} from 'slices/aiConversations/thunks'
import {
  addSavedSegmentId,
  openCampaignModal,
  selectAISegmentBuilder,
  setCampaignLoading,
  setMessageSegmentData,
} from 'slices/aiSegmentBuilder'
import type { MessageSegmentData } from 'slices/aiSegmentBuilder/types'

export function useAISegmentBuilderActions() {
  const dispatch = useDispatch()
  const { isCampaignLoading } = useSelector(selectAISegmentBuilder)

  const onSegmentSave = useCallback(
    (segmentData: SegmentSaveData) => {
      dispatch(saveSegmentThunk(segmentData))
    },
    [dispatch]
  )

  const onCampaignCreate = useCallback(
    (segmentId: number) => {
      dispatch(openCampaignModal(segmentId))
    },
    [dispatch]
  )

  const onCreateAnother = useCallback(() => {
    dispatch(createAnotherSegmentThunk())
  }, [dispatch])

  const setMessageSegmentDataForMessage = (
    messageId: string,
    data: Partial<MessageSegmentData>
  ) => {
    dispatch(setMessageSegmentData({ messageId, data }))
  }

  const setCampaignLoadingState = (loading: boolean) => {
    dispatch(setCampaignLoading(loading))
  }

  const addSavedSegmentIdToStore = (segmentId: number) => {
    dispatch(addSavedSegmentId(segmentId))
  }

  return {
    onCampaignCreate,
    onSegmentSave,
    onCreateAnother,
    isCampaignLoading,
    setMessageSegmentData: setMessageSegmentDataForMessage,
    setCampaignLoading: setCampaignLoadingState,
    addSavedSegmentId: addSavedSegmentIdToStore,
  }
}
